var path = 'src/app/patients/forms/questionnaire.html';
var html = "<h2 class=page-header>{{form.name}}</h2> <div form-component patient=patient form=form></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/forms/questionnaire.html
 ** module id = 468
 ** module chunks = 0
 **/